<template>
  <section>
    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <h1 class="has-text-weight-semibold is-size-4">Deactivation</h1>
          <p class="has-text-justified pb-2">
            You can <b>deactivate</b> your Costuto account by clicking the button
            below.<br />
            Once your account is deactivated,
            <b
              >your profile, projects, crafts, articles and collections won't be
              accessible</b
            >
            to other users anymore. <br />All of your previous comments will show your
            <b>username grayed out.</b> <br />
          </p>
          <p class="has-text-justified pb-2">
            If you change your mind, you can reactivate your account afterwards.
            <br />However, please note that
            <b class="has-text-danger"
              >if your account remains deactivated for more than 1 year</b
            >, we might take the decision to
            <b class="has-text-danger">delete it permanently</b>. <br />Please be careful
            and use this functionality with <b>caution</b>.
          </p>
          <b-button type="is-danger">Deactivate my Account</b-button>
        </div>
        <p class="has-text-justified pb-2 is-italic has-text-dark-orange">
          NOTE: Not implemented yet
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>
